import React from 'react'
import TeamMembers, { AboutUs } from '../../components/TeamMembers';

export default function About() {
  return <div>
  <AboutUs />
  <TeamMembers/>
  </div>
}
